import { Col } from 'antd';
import styled from 'styled-components';

export const ActionsInline = styled(Col)`
	display: flex;
	justify-content: center;
`;
